import { useState } from "react";
import { Link } from "react-router-dom";
import { t } from "../../i18n";

const FOOTER_CATEGORY_LINKS = [
  { label: "Yoga Products", path: "/products?group=Yoga%20Products" },
  { label: "Pilates Products", path: "/products?group=Pilates%20Products" },
  { label: "Home Fitness Equipment", path: "/products?group=Home%20Fitness" },
  { label: "Foam Rollers & Recovery", path: "/products?group=Foam%20Rollers" }
];

const FOOTER_SERVICE_POINTS = [
  "footerServicePointA",
  "footerServicePointB",
  "footerServicePointC",
  "footerServicePointD"
];

const FOOTER_LOGO_SRC = "/assets/about/logo-footer.png";

export default function StorefrontFooter({
  logoAlt = "",
  storefrontTitle = "LOYA SPORT",
  contactEmail = "",
  contactWhatsapp = ""
}) {
  const [email, setEmail] = useState("");
  const footerYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container site-footer-shell">
        <div className="site-footer-grid">
          <section className="site-footer-brand-column" aria-label={t("footerCompanyProfileAria")}>
            <Link to="/" className="site-footer-brand-lockup" aria-label={t("ariaBackToHomepage")}>
              <img className="site-footer-brand-logo" src={FOOTER_LOGO_SRC} alt={logoAlt || storefrontTitle} />
              <div className="site-footer-brand-wordmark">
                <strong>Loya</strong>
                <span>Sport</span>
              </div>
            </Link>
            <p className="site-footer-brand-copy">{t("footerBrandCopy")}</p>
          </section>

          <nav className="site-footer-column" aria-label={t("footerPopularCategoriesAria")}>
            <h4>{t("footerPopularCategoriesTitle")}</h4>
            <ul>
              {FOOTER_CATEGORY_LINKS.map((item) => (
                <li key={item.path}>
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <section className="site-footer-column" aria-label={t("footerBuyerSupportTitle")}>
            <h4>{t("footerBuyerSupportTitle")}</h4>
            <ul>
              {FOOTER_SERVICE_POINTS.map((point) => (
                <li key={point}>{t(point)}</li>
              ))}
            </ul>
          </section>

          <section className="site-footer-column" aria-label={t("footerContactAria")}>
            <h4>{t("contactUs")}</h4>
            <ul>
              {contactEmail ? <li>{contactEmail}</li> : null}
              {contactWhatsapp ? <li>{contactWhatsapp}</li> : null}
              <li>{t("footerLocationValue")}</li>
              <li>{t("footerServiceValue")}</li>
            </ul>
          </section>

          <section className="site-footer-column" aria-label={t("footerNewsletterTitle")}>
            <h4>{t("footerNewsletterTitle")}</h4>
            <p>{t("footerNewsletterDesc")}</p>
            <form
              className="site-footer-newsletter"
              onSubmit={(e) => {
                e.preventDefault();
                setEmail("");
              }}
            >
              <input
                type="email"
                placeholder={t("footerNewsletterPlaceholder")}
                aria-label={t("footerNewsletterPlaceholder")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit" aria-label="Subscribe">→</button>
            </form>
          </section>
        </div>

        <div className="site-footer-bottom">
          <p>© {footerYear} LOYA SPORT. {t("footerBottomCopyright")}</p>
        </div>
      </div>
    </footer>
  );
}
